import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

const PageContainer = styled.div`
  animation: ${({ $isTransitioning }) => $isTransitioning ? 'fadeIn 0.3s' : 'none'};
  opacity: ${({ $isTransitioning }) => $isTransitioning ? 1 : 1};
  transition: opacity 0.3s ease;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

// This component wraps a page and handles transition animations
function PageTransition({ children }) {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    // If location changes
    if (location.pathname !== displayLocation.pathname) {
      setIsTransitioning(true);
      
      // After a short delay, update the displayed location
      setTimeout(() => {
        setDisplayLocation(location);
        // Set transitioning to false after the content has changed
        setTimeout(() => {
          setIsTransitioning(false);
        }, 50);
      }, 250);
    }
  }, [location, displayLocation]);

  return (
    <PageContainer $isTransitioning={isTransitioning}>
      {children}
    </PageContainer>
  );
}

export default PageTransition;